import { render, staticRenderFns } from "./kiosk-terminals-info-modal.vue?vue&type=template&id=65ecff74&scoped=true"
import script from "./kiosk-terminals-info-modal.vue?vue&type=script&lang=js"
export * from "./kiosk-terminals-info-modal.vue?vue&type=script&lang=js"
import style0 from "./kiosk-terminals-info-modal.vue?vue&type=style&index=0&id=65ecff74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ecff74",
  null
  
)

export default component.exports